<div>
    <div style="margin-left: 80%;  margin-bottom: 2%;">
        <button [useExistingCss]="true" class="noPrint"
            style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;" mat-raised-button
            color="primary" printTitle="Label" printSectionId="print-section" ngxPrint>
            print
        </button>
        <!-- <button mat-raised-button class="btn btn-info noPrint" (click)="print()"
            style="margin-right: 2%; margin-left: 2%">
            Print
        </button> margin-bottom: 4%;margin-top: 1.5%; -->
        <button mat-dialog-close class="btn noPrint" style=" z-index: 10">Close</button>
    </div>
    <div class="wrapper" id="print-section" style="background-color: white;">
         <div class="header"> 
        <span style="margin-left: 5%;">दि.{{today | date:'dd/MM/yyyy hh:mm:ss'}} साप्तहिक विवेक - वर्गणी जमा असलेले</span>
        <span *ngIf="deliveryMode != ''" style="margin-left: 1%;">वितरण - {{ deliveryMode }}</span>
        <span *ngIf="repNames != ''" style="margin-left: 1%; display: flex; flex-direction: column;">
        <span>प्रतिनिधी - {{ firstRepName }}</span>
        <!-- <span>प्रतिनिधी पर्यंत - {{ lastRepName }}</span> -->
      </span>
      <!-- <span *ngIf="country != ''" style="margin-left: 1%;">देश- {{ country[0] }}</span>
      <span *ngIf="state != ''" style="margin-left: 1%;">राज्य- {{ state[0] }}</span> -->
      <span *ngIf="district != ''" style="margin-left: 1%;">जिल्हा - {{ district.join(', ') }}</span>
      <span *ngIf="taluka != ''" style="margin-left: 1%;">तालुका - {{ taluka.join(' , ') }}</span>
      <span *ngIf="disrep != ''" style="margin-left: 1%;">जिल्हा प्रतिनिधी - {{ disrep.join(' , ') }}</span>
      <span *ngIf="subname != ''" style="margin-left: 1%;">वर्गणीदार - {{ subname.join(' , ') }}</span>
      <span *ngIf="officerep != ''" style="margin-left: 1%;">कार्यालय प्रतिनिधी - {{ officerep.join(' , ') }}</span>
            </div>
        <table style="margin: 1cm 0.2cm 1cm 0.2cm">
            <thead>
                <tr>
                    <td>
                        <div class="header-space">&nbsp;</div>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <div class="row">
                            <!-- *ngFor="let item of data" -->
                            <div class="col-3" *ngFor="let item of displayData; let i=index"
                                style="min-height: 190px !important;padding-left: 50px !important;"
                                [style.page-break-inside]="'avoid'"
                                [ngClass]="{ 'print-margin-top': i > 27 , 'top-margin': (i > 11 && i < 27) , 'tops-margin': (i % 28 > 16)}">
                                <!-- <div *ngIf="i > 4 &&  i % 28 < 4;  "  [ngClass]="displayData.length >28 ?'page-break print-margin-top':''" ></div> -->
                                
                                <script type="text/javascript">
                                    window.onload = addPageNumbers;

                                    function addPageNumbers() {
                                        var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
                                        for (var i = 1; i <= totalPages; i++) {
                                            var pageNumberDiv = document.createElement("div");
                                            var pageNumber = document.createTextNode(" पृष्ठ क्र. " + i + " of " + totalPages);
                                            pageNumberDiv.style.position = "absolute";
                                            pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
                                            pageNumberDiv.style.height = "16px";
                                            pageNumberDiv.appendChild(pageNumber);
                                            document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
                                            pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
                                        }
                                    }
                                </script>

                                <!-- Your content here -->
                                  <ng-container *ngIf="item.name || item.address || item.mobileNumber; else blankLabel">
                                <span style="font-size: 12px; font-weight: 300; font-weight: bold;" *ngIf="iscustomer=='yes'">
                                    {{ item['short_name'] }}{{ item['month']}}/{{ item['subno']}}-{{ item['year'] }}
                                </span><br />
                                <span  [style.font-size.px]="(item.title + ' ' + item.name)?.length > 60 ? 12 : 15"  style="font-weight: 300; font-weight: bold;"> {{ item["title"] }} {{ item["name"]
                                    }}</span><br />
                                <span [style.font-size.px]="item.address?.length > 60 ? 12 : 15" style="font-size: 12px; font-weight: 300; font-weight: bold;">{{ item["address"] }} {{ item["taluka"] }}</span><br />
                                <!-- <span [style.font-size.px]="(item.taluka || '').length > 84 ? 13 : 15" style="font-size: 12px; font-weight: 300; font-weight: bold;">{{ item["taluka"] }}</span><br /> -->
                                <span [style.font-size.px]="(item.district || '').length > 40 ? 12 : 13" style="font-size: 12px; font-weight: 300; font-weight: bold;">{{ item["district"] }}</span>
                                <span style="font-size: 12px; font-weight: 300; font-weight: bold;" *ngIf="item['pincode'] != 0" [style.font-size.px]="( (item.pincode + ' ' + (item.state || '')) ).length > 40 ? 12 : 13"> - {{
                                    item["pincode"] }} {{ item["state"] }}</span><br>
                                
                                    <!-- <span style="display: inline-block;"> Sender:{{item['senderId']}} </span><br>
                                    <span style="display: inline-block;"> Weight:{{item['weight']}} </span><br> -->
                                    <span [style.font-size.px]="( (item.mobileNumber || '').length > 60 ? 12 : 15 )" style="font-size: 12px; font-weight: 300; font-weight: bold;">मो.
                                    नं. - {{
                                    item["mobileNumber"]
                                    }}</span><br>
                                    </ng-container>
                                    <!-- <span style="display: inline-block;">
                                        <ngx-barcode6 [bc-format]="'MSI'" [bc-value]="item['postalCode']"
                                            [bc-display-value]="true" [bc-width]="1" 
                                            [bc-height]="40"> 
                                        </ngx-barcode6>
                                    </span> -->
                                    
                                <ng-template #blankLabel>
    <div style="min-height: 160px;"></div>
  </ng-template>

                            </div>
                            <!-- <table style="width: 100%; border-collapse: collapse;">
                                <tr *ngFor="let row of chunkedData">
                                  <td *ngFor="let item of row" style="border: 0px solid #fff; vertical-align: top; padding: 30px;">
                                    <span style="font-size: 15px; font-weight: 400;" *ngIf="iscustomer=='yes'">
                                      {{ item['short_name'] }}{{ item['month'] }}/{{ item['subno'] }}-{{ item['year'] }}
                                    </span><br />
                                    <span style="font-size: 15px; font-weight: 400;">
                                      {{ item["title"] }} {{ item["name"] }}
                                    </span><br />
                                    <span style="font-size: 15px; font-weight: 400;">
                                      {{ item["address"] }}
                                    </span><br />
                                    <span style="font-size: 15px; font-weight: 400;">
                                      {{ item["taluka"] }}
                                    </span><br />
                                    <span style="font-size: 15px; font-weight: 400;">
                                      {{ item["district"] }}
                                      <span *ngIf="item['pincode'] != 0">
                                        - {{ item["pincode"] }} {{ item["state"] }}
                                      </span>
                                    </span><br />
                                    <span style="font-size: 15px; font-weight: 400;">
                                      मो. नं. - {{ item["mobileNumber"] }}
                                    </span>
                                  </td>
                                </tr>
                              </table> -->
                            <!-- <h3 class="first"></h3>-->
                            <!-- <div id="insert"></div> -->

                        </div>

                    </td>
                </tr>
            </tbody>
            <!-- <tfoot>
                <tr>
                    <td>
                        <div class="footer-space">&nbsp;</div>
                    </td>
                </tr>
            </tfoot> -->
        </table>
        <!-- <div class="header"> <span style="margin-left: 5%;">दि.{{today | date:'dd/MM/yyyy hh:mm:ss'}} साप्तहिक
                विवेक</span>
            </div> -->
        <!-- <div class="footer">...</div> -->
    </div>
</div>

<!-- <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js">
        var bottom = 0;
        $(document).ready(function () {
            $('.col-3:nth-child(100n)').each(function () {
                bottom -= 100;
                botString = bottom.toString();
                var $counter = $('h3.first').clone().removeClass('first');
                $counter.css('bottom', botString + 'vh');
                ($counter).insertBefore('.insert');
            });
        });
    </script> -->
<!-- </body> -->

  